"use client";

import { useEffect, useRef } from "react";
import { useTranslations } from "next-intl";

export function ContactSuccess({
  minHeight,
  onAgain,
}: {
  minHeight?: number;
  onAgain: () => void;
}) {
  const t = useTranslations("contact");
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    titleRef.current?.focus();
  }, []);

  return (
    <div
      className="flex flex-col items-center justify-center gap-[22px] rounded-home-28 border-[1.5px] border-home-navy bg-home-cream-2 px-10 py-10 text-center shadow-[10px_10px_0_rgba(15,27,45,0.14)]"
      style={minHeight ? { minHeight } : undefined}
    >
      <div className="home-contact-pop flex h-24 w-24 items-center justify-center rounded-full bg-home-accent">
        <svg
          viewBox="0 0 46 46"
          className="h-[46px] w-[46px]"
          aria-hidden="true"
        >
          <path
            d="M10 24.5 L19 33.5 L36 14"
            fill="none"
            stroke="var(--home-navy)"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            pathLength={1}
            className="home-contact-draw"
          />
        </svg>
      </div>
      <h3
        ref={titleRef}
        tabIndex={-1}
        // biome-ignore lint/a11y/useSemanticElements: the success title must stay a heading and expose role="status"
        role="status"
        className="text-[30px] font-bold leading-tight text-home-navy outline-none"
      >
        {t("successTitle")}
      </h3>
      <p className="max-w-md text-[18px] leading-snug text-home-body">{t("successBody")}</p>
      <button
        type="button"
        onClick={onAgain}
        className="inline-flex min-h-11 items-center justify-center rounded-home-pill bg-home-navy px-6 text-[16px] font-semibold text-home-cream hover:bg-home-navy-2"
      >
        {t("sendAnother")}
      </button>
    </div>
  );
}
